export function getThumbnailView(path, backendId){
    //console.log("test>>>>>",data);
    return fetch(`/api/v1/fetch/thumb/${backendId}/${path}`, {
        method: "GET",      
      }).then(async(response) => {
        if(!response.ok){
          const err = await response.json();
          //throw err;
        }
        return await response.blob()
    })
      .then(async(data) => {
        let objectURL = await URL.createObjectURL(data);
        console.log(objectURL);
        return objectURL;        
      })
      .catch(error => console.log(error));
}